import { ModuleConfig } from '@core/interfaces';
import { name as members } from '@modules/Members/reducers/members';

const config: ModuleConfig = {
  name: 'Members',
  baseUrl: '',
  routes: [
    {
      path: '/admin/inventory',
      page: 'InventoryHome',
      title: 'Inventory Page',
      exact: true
    },
    {
      path: '/admin/inventory/:idSellName',
      page: 'InventSellName',
      title: 'InventSellName Page',
      exact: true
    },
    {
      path: '/admin/inventory-details/:inventoryId/product/:productId',
      page: 'InventoryDetail',
      title: 'Inventory Page',
      exact: true
    }
  ],
  requireAuthenticated: true
};

export default config;
